// Shared empty state for the accounting matrix views (Investment ×
// Function, Treatment × Function, Teams). Shown when the org has no commit
// activity to total. Intentionally copy-less — just the connect-a-repo CTA.

import { CONNECT_REPO_CTA } from '../../components/EmptyState';

export const ACCOUNTING_EMPTY = { cta: CONNECT_REPO_CTA } as const;
